import { styled } from '@material-ui/core';
import { ICustomTheme } from 'interfaces';

export const StyledAsterixDetails = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    fontFamily: theme.typography.body1.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    paddingTop: theme.spacing(2),
  }),
);
